import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'castAs',
  pure: true,
})
export class CastAsPipe implements PipeTransform {
  transform<T>(value: any, _type: (new (...args: any[]) => T) | T): T {
    return value as T;
  }
}
